import { Role } from '@models/Role'
import { selectSelectedAdmin } from '@store/AdminReducer'
import { useAppSelector } from '@store/hooks'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Card, Flex, Form, Input } from 'antd'
import { useEffect } from 'react'
import { RoleFormItem } from './Form'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const rolesForm = Form.useWatch<RoleFormItem[]>('roles', form) || []
  const item = useAppSelector(selectSelectedAdmin())

  useEffect(() => {
    form.setFieldsValue({
      ...item,
      roles: item?.roles.map((roleId) => ({
        role: roleId,
        /**
         * This will work as long as only one extraModel is associated to a role
         * If in the future we have multiple extraModels per role, we will need to adjust this
         */
        entity: item.extraModels && item.extraModels[0]?.entity,
        extraIds: item.extraModels?.map((extraModel) => extraModel.model.id),
      })),
    })
  }, [item])

  if (item === undefined) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item name="id" hidden style={{ display: 'none' }}>
        <Input type="hidden" />
      </Form.Item>
      {/* At the moment only one role can be associated to an Admin
      Even though the API can handle multiple, we keep this posibility for later if needed
      That's why you will se mutliple things commented or unsued below
      */}
      <Form.List name="roles" initialValue={[{ roles: [{ role: null }] }]}>
        {(fields, { add, remove }) => (
          <Flex gap={16} vertical>
            {fields.map(({ key, name, ...restField }) => {
              const entity = rolesForm[name]?.['entity'] || null

              return (
                <Card
                  key={key}
                  title={'Role'}
                  // title={`Role ${name + 1}`}
                  // extra={<CloseOutlined onClick={() => remove(name)} />}
                  size="small"
                >
                  <Form.Item
                    {...restField}
                    label="Role"
                    name={[name, 'role']}
                    rules={[requiredRule()]}
                  >
                    <SBAsyncSelect<Role>
                      entity={Entity.role}
                      allowClear
                      overrideOptions={{
                        addExtraAttributes: (item) => ({ entity: item.entity }),
                      }}
                      onChange={(value, rawOption) => {
                        const option =
                          (Array.isArray(rawOption)
                            ? rawOption[0]
                            : rawOption) || null
                        // As we override onChange() method, we need to set role ourselves
                        form.setFieldValue(['roles', name, 'role'], value)
                        form.setFieldValue(
                          ['roles', name, 'entity'],
                          option?.entity
                        )
                      }}
                    />
                  </Form.Item>

                  <Form.Item {...restField} hidden name={[name, 'entity']}>
                    <Input hidden />
                  </Form.Item>

                  {entity && (
                    <Form.Item
                      {...restField}
                      label={'Specific access'}
                      name={[name, 'extraIds']}
                      rules={[requiredRule()]}
                    >
                      <SBAsyncSelect
                        placeholder={`Select ${entity}(s)`}
                        entity={entity}
                        multiple
                        allowClear
                      />
                    </Form.Item>
                  )}
                </Card>
              )
            })}

            {/* <Button type="dashed" onClick={() => add()} block>
              + Add role
            </Button> */}
          </Flex>
        )}
      </Form.List>
    </Form>
  )
}

export default Update
